import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import en from './locales/en.json';

const STORAGE_KEY = 'i18nextLng';

const initial =
  (typeof localStorage !== 'undefined' && (localStorage.getItem(STORAGE_KEY) as 'ru' | 'en' | null)) || 'ru';

function syncDocumentShell() {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = i18next.language;
  document.title = i18next.t('meta.documentTitle');
}

void i18next
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
    },
    lng: initial,
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  })
  .then(() => {
    syncDocumentShell();
  });

i18next.on('languageChanged', (lng: string) => {
  syncDocumentShell();
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    /* ignore */
  }
});

export default i18next;
